export default function ReceiptItem({ title, label }: { title: string; label: string }): React.ReactElement {
  return (
    <div>
      <div className="uppercase tracking-wider text-xxs text-gray-light-fade">{title}</div>
      <span>{label}</span>
    </div>
  )
}
